<template>
    <div :class="$style['about-css']">
        <div :class="$style['about-logo']">
            <img src="../assets/image/cluna/app_logo.png"/>
            <h3>فروشگاه کلانا</h3>
        </div>
        <div :class="$style['about-subject']">
            <span>{{this.url}}</span>
        </div>
        <div class="d-flex flex-row mr-auto ml-auto" style="width: fit-content">
            <div v-for="(item, index) in socials" :key="index">
                <img role="button" @click="oracle.openLink(item.social_url)" :src="item.social_avatar" style="width: 50px; height: 50px; transform: scale(0.6)" class="center-cropped"/>
            </div>
        </div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";

    export default {
        name: "About",
        data() {
            return {
                oracle: oracle,
                url: '',
                socials: []
            }
        },
        methods: {},
        mounted() {
            oracle.axios("setting/getInfo", {"filter_by": "website", "search_by": 'about'}, (response) => {
                this.url = response.data
            });
            oracle.axios('social/getList', {"order_by": "priority"}, (res) => {
                this.socials = res.data
            })
        }
    };
</script>
<style module>
    .about-css {
        width: 100%;
        height: 100%;
    }

    .about-css img {
        width: 30%;
        height: auto;
        margin-bottom: 30px;
    }

    .about-css .about-logo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-content: center;
        align-items: center;
        margin-top: 50px;
        margin-bottom: 50px;
    }

    .about-css .about-subject {
        padding: 10px 30px 10px 30px;
    }

    .about-css .about-subject span {
        font-size: 14px !important;
        text-align: justify;
    }

    .about-css .headerTop-basket {
        background: #4b4a4a;
        padding: 15px 10px;
        display: flex;
    }
</style>
